import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="porfolio-header">
      <button className="portfolio-btn" onClick={() => navigate("/")}>
        (404) Page not found ! | Go to Home
      </button>
    </div>
  );
};

export default NotFound;
